<template>
  <div class="card-list">
    <the-heading class="lg:mb-8 mb-5">
      {{ $t('ec-line012.title') }}
    </the-heading>
    <the-section :title="$t('ec-line012.paymentTitle')">
      <el-row class="mb-1 mt-4">
        <el-col class="font-black text-base text-gray-950">{{ $t('ec-line012.creditCardInformationTitle') }}</el-col>
      </el-row>
      <div class="flex flex-row flex-wrap w-full special_el-radio">
        <el-radio
          v-for="card in data"
          :key="card.card_seq"
          :label="card.card_seq"
          v-model="selected"
          class="radio-dot flex flex-row items-baseline mb-3 pl-2"
        >
          <div class="flex flex-row items-baseline justify-between">
            <div class="card_no">
              {{ Utils.helper.formatCard(card.card_no) }}
            </div>
            <div class="flex flex-row items-baseline justify-end">
              <div class="text-base">
                {{ $t('common.cardExpired', { month: card.expire.slice(2), year: card.expire.slice(0, 2) }) }}
              </div>
              <el-button
                class="text-2xl pt-5 pb-5 pr-2"
                type="text"
                icon="mdi mdi-chevron-right"
                @click.native="toEditCard(card.card_seq)"
              ></el-button>
            </div>
          </div>
        </el-radio>
      </div>
      <el-row v-if="data.length < 5" class="lg:text-center">
        <el-button class="list-action--btn" @click="toEditCard()">{{ $t('ec-line012.newCreditCardBtn') }}</el-button>
      </el-row>
    </the-section>

    <div class="flex flex-col items-center lg:flex-row justify-center">
      <el-button class="submit-btn mt-5 lg:mt-8 lg:mb-4 lg:mx-2 lg:order-1 whitespace-pre" @click="onSubmit">
        {{ submitText }}
      </el-button>
      <el-button class="cancel-btn mt-8 mb-1 lg:mb-4 lg:mx-2" @click="onCancel">{{
        $t('common.action.cancel')
      }}</el-button>
    </div>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import TheSection from '@/components/my-page-partials/TheSection.vue'
export default {
  components: { TheHeading, TheSection },
  props: {
    isDialog: Boolean,

    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: [String, Number],
      required: false,
      default: () => '',
    },
    cancel: {
      type: Function,
      required: false,
      default: null,
    },
    submit: {
      type: Function,
      required: false,
      default: null,
    },
    submitText: {
      type: String,
      default: function () {
        return this.$t('common.action.setPaymentMethod')
      },
    },
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    value(val) {
      this.selected = val
    },
  },
  methods: {
    toEditCard(cardSeq = '') {
      this.$emit('to-detail', cardSeq)
    },
    async onSubmit() {
      if (this.submit) {
        if (!this.selected) return
        await this.submit(this.selected)
      }
    },
    onCancel() {
      if (this.cancel) {
        this.cancel()
        return
      }
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/css/base/variables.scss';
.special_el-radio {
  .el-radio {
    @apply border border-solid border-gray-150 rounded-md;
    margin-right: 0;
    width: 100%;

    &__label {
      width: 100%;
    }
    .card_no {
      @apply text-base;
    }

    &.is-checked {
      border: 2px solid var(--brand-color);
      background-color: var(--brand-color-20);

      .card_no {
        @apply text-body-01;
      }
    }
  }
}
</style>
